import { c as _c } from "react/compiler-runtime";
import { ChangeEventHandler, ComponentPropsWithoutRef, FormEventHandler, MouseEventHandler, ReactNode, createContext, useContext } from 'react';
import { Group } from '@/uiComposites/form/Group';
import { Labeled } from '@/uiComposites/form/Labeled';
import { checkboxCSS } from '@/uiComposites/form/checkbox.css';
import { classes } from '@/uiPrimitives/base/classes.helpers';
import { radioCSS } from '@/uiComposites/form/radio.css';
import { shelf } from '@/uiPrimitives/layout/shelf';
import { textBlock } from '@/uiPrimitives/typography/text';
import { stack } from '@/uiPrimitives/layout/stack';
import { h3TextBlock } from '@/uiComposites/typography/headings';
import { callToActionBox, secondaryButton } from '@/uiComposites/interactive/callToAction';
import { box } from '@/uiPrimitives/layout/box';
import { indentSize } from '@/uiPrimitives/layout/indentSize.definitions';
import { occupy } from '@/uiPrimitives/layout/occupy';
import { hiddenAccessibleUnlessUserInvalid, hiddenUnlessUserInvalid, invalidButton } from '../../DecisionTool.css';
import { FieldIssue } from '@/app/contactOverview/[contactOverview]/contactForm/[contactForm]/FieldIssue';
import { inline } from '@/uiPrimitives/utility/display.css';
import { pile } from '@/uiPrimitives/layout/pile';
import { AnyRenderedQuestion, GivenAnswers } from '../question.types';
import { addTestSelector, testSelectorAttribute } from '@/globals/testHelpers/testSelector';
export const Form = props => {
  const $ = _c(6);
  let t0;
  if ($[0] !== props) {
    t0 = event => {
      event.preventDefault();
      if (event.currentTarget.checkValidity()) {
        props.onSubmit(event);
      }
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(box({
      backgroundColor: "negativeBlue",
      paddingInline: indentSize,
      paddingBlockStart: "3 | h1"
    }), stack({
      rowGap: "7 | betweenH3Sections"
    }));
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props || $[4] !== t0) {
    t2 = <form {...props} noValidate={true} onSubmit={t0} className={t1} />;
    $[3] = props;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export const FormError = t0 => {
  const $ = _c(3);
  const {
    children,
    id
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== id) {
    t1 = <FieldIssue id={id} className={hiddenAccessibleUnlessUserInvalid} hiddenClassName={hiddenUnlessUserInvalid}>{children}</FieldIssue>;
    $[0] = children;
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const Fieldset = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(stack({
      rowGap: "5 | betweenParagraphs"
    }));
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <div {...props} className={t0} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export const QuestionTitle = t0 => {
  const $ = _c(7);
  const {
    children,
    id
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(h3TextBlock({}));
    t2 = classes();
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <span className={t2}>{children}</span>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== id || $[5] !== t3) {
    t4 = <div id={id} tabIndex={-1} className={t1}>{t3}</div>;
    $[4] = id;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const QuestionSubtitle = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div>{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const StackAnswers = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(stack({
      rowGap: "4 | betweenListItems"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const AnswerContainer = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(shelf({}));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <Labeled.Container><div className={t1}>{children}</div></Labeled.Container>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const Checkbox = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(occupy({
      inlineSize: indentSize,
      blockSize: "capSize",
      justifyItems: "start"
    }));
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(checkboxCSS);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <span className={t0}><Labeled.Input {...props} type="checkbox" className={t1} /></span>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const Radio = props => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = classes(occupy({
      inlineSize: indentSize,
      blockSize: "capSize",
      justifyItems: "start"
    }));
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(radioCSS);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <span className={t0}><Labeled.Input {...props} type="radio" className={t1} /></span>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export const AnswerLabel = t0 => {
  const $ = _c(9);
  const {
    children,
    helpSlot
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(textBlock({}));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classes(inline);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <Labeled.Label className={t2}>{children}</Labeled.Label>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== helpSlot) {
    t4 = Boolean(helpSlot) && <>{"\xA0\xA0"}{helpSlot}</>;
    $[4] = helpSlot;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export const ButtonShelf = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(shelf({
      columnGap: "1 | h3",
      gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
      justifyContent: "start"
    }), box({
      inlineSize: "fit-content"
    }));
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className={t1}>{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export const SecondaryButton = ({
  children,
  onClick,
  [testSelectorAttribute]: dataUITest
}: {
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  [testSelectorAttribute]?: string;
}) => {
  return <button type="button" onClick={onClick} className={classes(secondaryButton({
    box: {
      inlineSize: 'auto'
    }
  }))} {...addTestSelector(dataUITest)}>
			{children}
		</button>;
};
export const SubmitButton = t0 => {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classes(callToActionBox({}), invalidButton);
    t2 = classes(pile({
      alignItems: "center"
    }));
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <button type="submit" className={t1}><span className={t2}>{children}</span></button>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
export type GetHasUnansweredQuestions = (Props: {
  allQuestions: Array<AnyRenderedQuestion>;
  givenAnswers: GivenAnswers;
}) => boolean;
export const GetHasUnansweredQuestionsContext = createContext<GetHasUnansweredQuestions | undefined>(undefined);
export const useHasUnansweredQuestions = props => {
  const $ = _c(3);
  const getHasUnansweredQuestions = useContext(GetHasUnansweredQuestionsContext);
  if (!getHasUnansweredQuestions) {
    throw new Error("GetHasUnansweredQuestionsContext was used without a provider");
  }
  let t0;
  if ($[0] !== getHasUnansweredQuestions || $[1] !== props) {
    t0 = getHasUnansweredQuestions(props);
    $[0] = getHasUnansweredQuestions;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};